import { render } from "./TheRadiobox.vue?vue&type=template&id=2a4127de&scoped=true"
import script from "./TheRadiobox.vue?vue&type=script&lang=js"
export * from "./TheRadiobox.vue?vue&type=script&lang=js"

import "./TheRadiobox.vue?vue&type=style&index=0&id=2a4127de&scoped=true&lang=css"

import exportComponent from "C:\\Users\\haqua\\Documents\\vue\\rebrand\\feedback-page-resell\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2a4127de"]])

export default __exports__